import BlockComponentText from '../BlockComponentValues/BlockComponentText';
import BlockComponentButton, { ButtonSize } from '../BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../BlockComponentValues/BlockComponentImage';
import { BlockJustify } from '../BlockSettings';
import { ColorPickerColors } from '../ColorPicker';

export enum BlockCardCenteredVariant {
  Left = 'left',
  Right = 'right',
}
class BlockCardCenteredData {
  variant: BlockCardCenteredVariant;
  title?: BlockComponentText;
  description?: BlockComponentText;
  mainImage?: BlockComponentImage;
  backgroundImage?: BlockComponentImage;
  button?: BlockComponentButton;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockCardCenteredData {
  export function make(
    variant: BlockCardCenteredVariant,
    backgroundImage: string,
    title?: string,
    description?: string,
    mainImage?: string,
    button?: BlockComponentButton,
  ): BlockCardCenteredData {
    return {
      variant,
      title: title ? BlockComponentText.make(title) : undefined,
      description: description ? BlockComponentText.make(description) : undefined,
      mainImage: mainImage ? BlockComponentImage.make(mainImage) : undefined,
      backgroundImage: BlockComponentImage.make(backgroundImage),
      button,
    };
  }

  export function getDefault(
    variant = BlockCardCenteredVariant.Left,
    image = '',
    buttonJustify = BlockJustify.CENTER,
    title = 'Heading',
    description = 'Text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text text.',
  ): BlockCardCenteredData {
    return make(
      variant,
      undefined,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      `<p>${description}</p>`,
      image,
      BlockComponentButton.getDefault(ButtonSize.MEDIUM, ColorPickerColors.BLUE, buttonJustify),
    );
  }
}

export default BlockCardCenteredData;
